// import React, { useEffect, useState } from "react";
// import styles from "./Thankyou.module.css";
// import {
//   useNavigate,
//   useParams,
//   useLocation,
//   useSearchParams,
// } from "react-router-dom";
// import { API_BASE_URL, token, verifyOrCreateUser } from "../../Store/apiStore";
// import { useRef } from "react";
// import Loader2 from "../Loader2/Loader2";
// import LottieAnimation from "../../lib/LottieAnimation";
// import useUser from "../../Store/Context/UserContext";
// import axios from "axios";

// function Thankyou({ onSubmit, isAgentCreated }) {
//   const [animationData, setAnimationData] = useState(null);
//   const { user, setUser } = useUser();


//   if (isAgentCreated === true) {
//     localStorage.setItem("agentCeated", true)
//   }
//   const hasRunRef = useRef(false);

//   const convFiredRef = useRef(false);
//   const navigate = useNavigate();
//   const { id: paramMode } = useParams();
//   const [searchParams] = useSearchParams();
//   const queryMode = searchParams.get("mode");

//   // Prefer query param if available, else fallback to URL paramm
//   const key = queryMode || paramMode;
  

//   const location = useLocation();

//   const [popupType, setPopupType] = useState(null);
//   const [popupMessage, setPopupMessage] = useState("");
//   const [message, setMessage] = useState("");

//   const [invoiceLink, setInvoiceLink] = useState("");
//   const [loading, setLoading] = useState(true);
//   // Get query params
//   const getQueryParam = (name) =>
//     new URLSearchParams(location.search).get(name);

//   const subscriptionId = getQueryParam("subscriptionId");
//   const agentId = getQueryParam("agentId");
//   const userId = getQueryParam("userId");
//   const subsid = getQueryParam("subscriptionId"); 
//   const agentName1 = getQueryParam("agentName"); 
//   const agentCode1 = getQueryParam("agentCode"); 
//   const businessName1 = getQueryParam("businessName"); 
//   const isFree = getQueryParam("isFree")
//   console.log({isFree});
  
//   const [subscriptionInfo, setSubscriptionInfo] = useState(null);
//   const [currencySymbol, setCurrencySymbol] = useState("");

//   const currentLocation = "/update";

//   const [agentName, setAgentName] = useState("Agent");
//   const [agentCode, setAgentCode] = useState("XXXXXX");
//   const [businessName, setBusinessName] = useState("Your Business");
//   const [showAnimation, setShowAnimation] = useState(false)

//   // Admin Logic
//   // near other useState hooks
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);
//   const [isLoadingRequest, setIsLoadingRequest] = useState(false);


//   const isAdmin = ((searchParams.get("isAdmin") || "").toLowerCase() === "true");


//   const deactivateAgentSubs = async (agentId) => {
//     if (!agentId) return { ok: false, error: "agentId missing" };

//     try {

//       const resp = await fetch(`${API_BASE_URL}/admin-inactive-deffer-payments`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ agentId: agentId }),
//       });

//       const json = await resp.json();
//       if (!resp.ok) return { ok: false, error: json?.error || "Failed to deactivate" };
//       return { ok: true, data: json };
//     } catch (e) {
//       console.error("deactivateAgentSubs error:", e);
//       return { ok: false, error: "Network error" };
//     }
//   };

//   // add this function
//   const adminHandleClick = async () => {
//     try {
//       setIsButtonDisabled(true);
//       setIsLoadingRequest(true);
//       const resp = await fetch(
//         `${API_BASE_URL}/admin-checkout-user-details`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ userId }),
//         }
//       );
//       // const sessionData = getSessionData();
//       const payload1 = await resp.json();
//       const email = payload1?.data?.email;
//       const customerId = payload1?.data?.customerId;
//       const fullOtp = "notRequired";


//       if (!email || !customerId) {
//         console.warn("Missing required info to verify.");
//         return;
//       }
//       const data = await verifyOrCreateUser(email, fullOtp, customerId);

//       if (data?.res1) {
//         const verifyStatus = data?.res1?.data?.verifiedStatus === true;

//         if (verifyStatus === true) {
//           const userData = {
//             name: data?.res?.data?.user?.name || "",
//             profile:
//               `${API_BASE_URL?.split("/api")[0]}${(data?.res?.data?.profile || "").split("public")[1] || ""
//               }` || "images/camera-icon.avif",
//             subscriptionDetails: {},
//           };
//           setUser(userData)
//           // if you have a setter/context, call it here
//           localStorage.setItem("onboardComplete", "true");
//           localStorage.setItem("token", data.res?.data?.token);
//           localStorage.setItem("onboardComplete", true);
//           localStorage.setItem("paymentDone", true);
//           // localStorage.setItem("subcriptionIdUrl", subcriptionId);
//         }


//         //  Deactivate older subs with subscription_status = 9 for this agent
//         if (agentId) {
//           const deact = await deactivateAgentSubs(agentId);
//           if (!deact.ok) {
//             console.warn("Could not deactivate old deffer subscription:", deact.error);
//           }
//         }


//         navigate("/dashboard");
//         return;
//       }

//       navigate("/dashboard", { replace: true });
//     } catch (err) {
//       console.error("Error during admin verification:", err);
//     } finally {
//       setIsButtonDisabled(false);
//       setIsLoadingRequest(false);
//     }
//   };

//   const defaultHandleClick = () => {
//     if (key !== "create") {
//       localStorage.removeItem("selectedPlanData");
//       localStorage.removeItem("allPlans");
//       navigate("/dashboard", { state: { currentLocation } });
//     } else {
//       setShowAnimation(true);
//       localStorage.removeItem("selectedPlanData");
//       localStorage.removeItem("allPlans");
//       setTimeout(() => {
//         navigate("/dashboard", { replace: true });
//       }, 6000);
//     }
//   };

//   const onDashboardClick = async () => {
//     sessionStorage.removeItem("oldSubsId")
//     if (isAdmin) {
//       await adminHandleClick();
//     } else {
//       defaultHandleClick();
//     }
//   };



//   useEffect(() => {
//     const storedDashboard = sessionStorage.getItem("dashboard-session-storage");
//     const storedBusinessDetails = sessionStorage.getItem("businessDetails");
//     const storedPlaceDetails = sessionStorage.getItem("placeDetailsExtract");

//     try {
//       if (key === "update" && storedDashboard) {
//         const parsed = JSON.parse(storedDashboard);
//         const agents = parsed?.state?.agents || [];
//         const matchedAgent = agents.find((a) => a.agent_id === agentId);

//         if (matchedAgent) {
//           setAgentName(matchedAgent.agentName || "Agent");
//           setAgentCode(matchedAgent.agentCode || "XXXXXX");
//           setBusinessName(
//             matchedAgent.business?.businessName || "Your Business"
//           );
//         } else {
//           console.warn("No matching agent found for agentId:", agentId);
//         }
//       }

//       if (key === "create") {
//         let businessNameVal = "";

//         const businessData = storedBusinessDetails
//           ? JSON.parse(storedBusinessDetails)
//           : null;
//         const placeData = storedPlaceDetails
//           ? JSON.parse(storedPlaceDetails)
//           : null;

//         setAgentCode(sessionStorage.getItem("AgentCode") || "XXXXXX");
//         setAgentName(sessionStorage.getItem("agentName") || "Agent");

//         // 1. From businessDetails first
//         if (businessData) {
//           // setAgentCode(businessData.AgentCode || "XXXXXX");
//           // setAgentName(businessData.agentName || "Agent");

//           businessNameVal = businessData.businessName;
//         }

//         // 2. If missing, fallback to placeDetailsExtract
//         if (!businessNameVal && placeData?.businessName) {
//           businessNameVal = placeData.businessName;
//         }

//         setBusinessName(businessNameVal || "Your Business");
//         // ✅ Load plan details from localStorage
//         const selectedPlanRaw = localStorage.getItem("selectedPlanData");
//         if (selectedPlanRaw) {
//           try {
//             const plan = JSON.parse(selectedPlanRaw);

//             setSubscriptionInfo({
//               planName: plan.planName || "N/A",
//               planAmount: plan.price || 0,
//               planMins: plan.planMins || "N/A",
//               interval: plan.interval || "month",
//               currentPeriodStart:
//                 plan.currentPeriodStart || new Date().toISOString(),
//               nextRenewalDate: plan.nextBillingDate || null,
//               invoiceUrl: plan.invoiceUrl || null,
//             });
//           } catch (err) {
//             console.warn(
//               "Failed to parse selected plan data from localStorage:",
//               err
//             );
//           }
//         }
//       }

//       if (key === "msgPlan") {
//         // console.log("dadadsadada")
//         let aa = sessionStorage.getItem("bussinessName")
//           setAgentCode(sessionStorage.getItem("AgentCode"));
//         setAgentName(sessionStorage.getItem("agentName"));
   
//         setBusinessName(sessionStorage.getItem("bussinessName"))
//         let businessNameVal = "";

//         const businessData = storedBusinessDetails
//           ? JSON.parse(storedBusinessDetails)
//           : null;

//         // console.log("businessData",businessData);
        
//         const placeData = storedPlaceDetails
//           ? JSON.parse(storedPlaceDetails)
//           : null;

      

//         // 1. From businessDetails first
//         if (businessData) {
//           // setAgentCode(businessData.AgentCode || "XXXXXX");
//           // setAgentName(businessData.agentName || "Agent");

//           businessNameVal = businessData.businessName;
//         }

//         // 2. If missing, fallback to placeDetailsExtract
//         if (!businessNameVal && placeData?.businessName) {
//           businessNameVal = placeData.businessName;
//         }

//         // console.log("businessNameVal",businessNameVal)

//         setBusinessName(businessNameVal || "Your Business");
//         // ✅ Load plan details from localStorage
//         const selectedPlanRaw = localStorage.getItem("selectedPlanData");
//         if (selectedPlanRaw) {
//           try {
//             const plan = JSON.parse(selectedPlanRaw);

//             setSubscriptionInfo({
//               planName: plan.planName || "N/A",
//               planAmount: plan.price || 0,
//               planMins: plan.planMins || "N/A",
//               interval: plan.interval || "month",
//               currentPeriodStart:
//                 plan.currentPeriodStart || new Date().toISOString(),
//               nextRenewalDate: plan.nextBillingDate || null,
//               invoiceUrl: plan.invoiceUrl || null,
//             });
//           } catch (err) {
//             console.warn(
//               "Failed to parse selected plan data from localStorage:",
//               err
//             );
//           }
//         }
//       }
//     } catch (e) {
//       console.error("Failed to parse session storage values:", e);
//     }
//   }, [agentId, key]);
//   const cancelOldSubscription = async () => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/cancel-subscription`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,

//         },
//         body: JSON.stringify({ subscriptionId: subsid }),
//       });

//       const result = await res.json();

//       if (!res.ok) {
//         console.error(
//           "❌ Failed to cancel subscription:",
//           result.error || result.message
//         );
//       } else {
//         console.log("✅ Old subscription cancelled:", result);
//       }
//     } catch (error) {
//       console.error("❌ Error cancelling subscription:", error);
//     }
//   };

//   const callNextApiAndRedirect = async () => {
  

//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/agent/updateFreeAgent`,

//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ userId, agentId }),
//         }
//       );

//       const data = await res.json();

//       if (data.success) {
//         setPopupType("success");
//         setPopupMessage("Agent upgraded successfully!");
//         if (subsid) {
//           await cancelOldSubscription();
//         }
//       } else {
//         setPopupType("failed");
//         setPopupMessage("Error completing subscription.");
//       }
//     } catch (error) {
//       console.error("❌ API call failed:", error);
//       setPopupType("failed");
//       setPopupMessage("Error completing subscription.");
//     }
//   };
//   // hello
//   const fetchSubscriptionInfo = async () => {
//     if (!agentId && !userId) return; // Ensure at least one ID exists

//     try {
//       const res = await fetch(`${API_BASE_URL}/subscription-details`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(
//           agentId ? { agentId } : { userId } // Send only one key based on availability
//         ),
//       });

//       const data = await res.json();
//       // console.log("Subscription Info:", data);

//       if (data && !data.error) {
//         setSubscriptionInfo(data);
//         const currencyMap = {
//           USD: "$",
//           INR: "₹",
//           EUR: "€",
//           GBP: "£",
//           AUD: "A$",
//           CAD: "C$",
//         };
//         const upperCurrency = data.currency?.toUpperCase() || "USD";
//         const symbol = currencyMap[upperCurrency] || "$";
//         setCurrencySymbol(`${upperCurrency} ${symbol}`);
//         // Save invoice link
//         if (data.invoiceUrl) {
//           setInvoiceLink(data.invoiceUrl);
//         }
//       } else {
//         console.warn("No subscription found, falling back to static info.");
//       }
//     } catch (error) {
//       console.error("Failed to fetch subscription info:", error);
//     }
//   };

//   const formatPrice = (price) => {
//     return new Intl.NumberFormat("en-IN").format(price);
//   };



//   const fetchSubscriptionInfoMsg = async () => {
//     if (!agentId && !userId) return; // Ensure at least one ID exists

//     try {
//       const res = await fetch(`${API_BASE_URL}/subscription-details-msg`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(
//           agentId ? { agentId } : { userId } // Send only one key based on availability
//         ),
//       });

//       const data = await res.json();
//       // console.log("Subscription Info:", data);

//       if (data && !data.error) {
//         setSubscriptionInfo(data);
//         // Extract currency symbol
//         const currencyMap = {
//           USD: "$",
//           INR: "₹",
//           EUR: "€",
//           GBP: "£",
//           AUD: "A$",
//           CAD: "C$",
//         };
//         const upperCurrency = data.currency?.toUpperCase() || "USD";
//         const symbol = currencyMap[upperCurrency] || "$";
//         setCurrencySymbol(`${upperCurrency} ${symbol}`);
//         // Save invoice link
//         if (data.invoiceUrl) {
//           setInvoiceLink(data.invoiceUrl);
//         }
//       } else {
//         console.warn("No subscription found, falling back to static info.");
//       }
//     } catch (error) {
//       console.error("Failed to fetch subscription info:", error);
//     }
//   };


//   useEffect(() => {
//     // console.log("dddddddddd");


//     if (hasRunRef.current) return;
//     hasRunRef.current = true;

//     const hasHandledThankYou = localStorage.getItem("hasHandledThankYou");

//     localStorage.setItem("hasHandledThankYou", "true");
//     // console.log("hasHandledThankYou", hasHandledThankYou)

//     const shouldRunUpdateAgent = key === "update" && agentId && userId;
//     const shouldRunWithStripeFlow = subscriptionId && agentId && userId;
//     const shouldRunCreateFlow = key === "create" && userId;

//     const shouldMsgCheck = key === "msgPlan"
//     // console.log(shouldMsgCheck, "gashas");

// const cancelOldSubscription = async () => {
//   try {
//     let subscriptionId = sessionStorage.getItem("oldSubsId")
//     if (!subscriptionId) throw new Error("subscriptionId is required");

//     // Call your backend cancel API
//     const response = await axios.post(`${API_BASE_URL}/cancelMessage-plan`, {
//       subscriptionId,
//     });

//     // console.log("Cancel response:", response.data);

  
//   } catch (error) {
//     console.error("Error canceling subscription:", error);
   
//   }
// };

//     const run = async () => {
//       try {
//         setLoading(true);
//         if (shouldMsgCheck) {
//           // console.log("doneeeee this workkkk");

//           await new Promise((resolve) => setTimeout(resolve, 1500));
         
//            let subscriptionId = sessionStorage.getItem("oldSubsId")
//           if(subscriptionId){
//   await cancelOldSubscription()
//   await fetchSubscriptionInfoMsg();
 
//           }
//           else{
//        await fetchSubscriptionInfoMsg();
//           }
         
//         }
//         else if (shouldRunWithStripeFlow || shouldRunUpdateAgent) {
//           await callNextApiAndRedirect(); 
//           await new Promise((resolve) => setTimeout(resolve, 1500));
//           await fetchSubscriptionInfo();
//         } else if (shouldRunCreateFlow) {
//           await new Promise((resolve) => setTimeout(resolve, 1500));
//           await fetchSubscriptionInfo();
//           if (!hasHandledThankYou) {
//             onSubmit();
//           }
//           // else if (shouldMsgCheck) {
//           //   console.log("doneeeee this workkkk");

//           //   await new Promise((resolve) => setTimeout(resolve, 1500));
//           //   await fetchSubscriptionInfoMsg();
//           // }
//         }
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoading(false); // 🔁 Now it happens *after* data fetch
//       }
//     };

//     run();
//   }, [key, subscriptionId, agentId, userId, subsid, isAdmin]);

//   const formatCurrency = (amount, currency) => {
//     const upperCurrency = currency?.toUpperCase() || "USD";

//     const symbolMap = {
//       USD: "$",
//       INR: "₹",
//       EUR: "€",
//       GBP: "£",
//       AUD: "A$",
//       CAD: "C$",
//       // Add more if needed
//     };

//     const symbol = symbolMap[upperCurrency] || "";

//     return `${upperCurrency} ${symbol}${Number(amount).toLocaleString()}`;
//   };
//   useEffect(() => {
//     fetch("/animations/Lottie_Loader.json")
//       .then((res) => res.json())
//       .then((data) => setAnimationData(data))
//       .catch((err) => console.error("Error loading animation:", err));
//   }, []);
//   useEffect(() => {
//     if (loading || !subscriptionInfo) return; 
//     if (convFiredRef.current) return; 
//     if (typeof window.gtag !== "function") return; 

//     window.gtag("event", "conversion", {
//       send_to: "AW-17437749926/M6gmCJzi-v8aEKbl-_pA",
//       value: Number(subscriptionInfo.planAmount || 1.0),
//       currency: (subscriptionInfo.currency || "USD").toUpperCase(),
//       transaction_id:
//         subscriptionInfo.subscriptionId ||
//         `${userId || "uid"}-${Date.now()}`, 
//     });
//     convFiredRef.current = true;
//   }, [loading, subscriptionInfo, subscriptionId, userId]);
//   return (

//     <>

//       {showAnimation ?
//         <>
//           <div className={styles.container}>
//             <br /> <br />
//             <div className={styles.Logo}>
//               <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
//             </div>
//           </div>
//           <div className={styles.animationContainer}>
//             <div className={styles.animationContent}>
//               <LottieAnimation animationData={animationData} width={300} height={300} />
//               <p className={styles.loaderText}><b>Setting up your agent... </b><br /><br /> Please Wait</p>
//             </div>

//           </div>
//         </>

//         :
//         subscriptionInfo ? <div>
//           <div className={styles.container}>
//             <div className={styles.Logo}>
//               <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
//             </div>

//             <div className={styles.ThankyouMsg}>
//               <div className={styles.title}>Thanks!</div>
//               <div className={styles.subtitle}>for your Purchase</div>
//               <p className={styles.description}>
//                 Your payment was successful. We’ve sent you a confirmation email
//                 with all the details you need.
//               </p>
//             </div>

//             {loading ? (
//               <Loader2 />
//             ) : (
//               <div className={styles.infoBox}>
//                 <p>Below is some Quick Info for your Reference:</p>
//                 <div className={styles.row}>
//                   <span>Business Name:</span>{" "}
//                   <div className={styles.Right50}>
//                     {isAdmin ? businessName1 : (key === "msgPlan" ? sessionStorage.getItem("bussinessName") :  businessName || "ACME Construction Services")}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Agent Name & ID:</span>
//                   <div className={styles.Right50}>
//                     {isAdmin
//                       ? agentName1 && agentCode1
//                         ? `${agentName1} (${agentCode1})`
//                         : "Oliver (HS23D4)"
//                       : agentName && agentCode
//                         ? `${agentName} (${agentCode})`
//                         : "Oliver (HS23D4)"}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Plan Activated:</span>
//                   <div className={styles.Right50}>
//                     {subscriptionInfo?.planName || "Growth"} -{" "}
//                     { key === "msgPlan" ? subscriptionInfo.planMessage : subscriptionInfo?.planMins|| "1500" } 
//                     {key === "msgPlan" ?  " Messages" : " Minutes"}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Frequency & Price:</span>
//                   <div className={styles.Right50}>
//   {isFree === "true" ? (
//     "US $299 / month"
//   ) : subscriptionInfo ? (
//     `${currencySymbol}${formatPrice(
//       subscriptionInfo?.metadata?.original_plan_amount
//     )} / ${subscriptionInfo.interval}`
//   ) : (
//     "US $499 / month"
//   )}
// </div>

//                 </div>
//                 {/* <div className={styles.row}>
//             <span>Discount Applied:</span>
//             <div className={styles.Right50}>N/A</div>
//           </div> */}
//                 <div className={styles.row}>
//                   <span>Billed Today:</span>
//                   <div className={styles.Right50}>
//                     {subscriptionInfo ? (
//                       <>
//                         {`${currencySymbol}${formatPrice(
//                           subscriptionInfo.planAmount
//                         )} on `}
//                         {new Date(
//                           subscriptionInfo.currentPeriodStart
//                         ).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "long",
//                           day: "numeric",
//                         })}
//                       </>
//                     ) : (
//                       "$5,688.60 on July 12, 2025"
//                     )}
//                   </div>
//                 </div>

//                 <div className={styles.row}>
//                   <span>Next Billing Date:</span>
//                   <div className={styles.Right50}>
//   {subscriptionInfo ? (
//     isFree === "true" ? (
//       // FREE → currentPeriodStart + 7 days
//       new Date(
//         new Date(subscriptionInfo.currentPeriodStart).getTime() +
//           7 * 24 * 60 * 60 * 1000
//       ).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     ) : (
//       // NOT FREE → show nextRenewalDate
//       new Date(subscriptionInfo.nextRenewalDate).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     )
//   ) : (
//     "06 July 2026"
//   )}
// </div>

//                 </div>
//                 {invoiceLink && (
//                   <div className={styles.row}>
//                     <span>Invoice Link:</span>
//                     <div className={styles.Right50}>
//                       <a
//                         href={invoiceLink}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className={styles.downloadButton}
//                         style={{
//                           color: "purple",
//                           textDecoration: "none",
//                           cursor: "pointer",
//                         }}
//                         download
//                       >
//                         Download
//                       </a>
//                     </div>
//                   </div>
//                 )}

//                 <div className={styles.ButtonTakeME}>
//                   <button
//                     onClick={onDashboardClick}
//                     className={styles.dashboardBtn}
//                     disabled={isButtonDisabled || isLoadingRequest || (key === "create" ? !isAgentCreated : false)}
//                   >
//                     {isLoadingRequest
//                       ? "Redirecting..."
//                       : key === "create"
//                         ? (isAgentCreated ? "Take me to Dashboard" : "Thinking...")
//                         : "Take me to Dashboard"}
//                   </button>

//                 </div>
//               </div>
//             )}
//           </div>
//         </div> : <Loader2 />}



//     </>
//   );
// }

// export default Thankyou;



// import React, { useEffect, useState } from "react";
// import styles from "./Thankyou.module.css";
// import {
//   useNavigate,
//   useParams,
//   useLocation,
//   useSearchParams,
// } from "react-router-dom";
// import { API_BASE_URL, token, verifyOrCreateUser } from "../../Store/apiStore";
// import { useRef } from "react";
// import Loader2 from "../Loader2/Loader2";
// import LottieAnimation from "../../lib/LottieAnimation";
// import useUser from "../../Store/Context/UserContext";
// import axios from "axios";

// function Thankyou({ onSubmit, isAgentCreated }) {
//   const [animationData, setAnimationData] = useState(null);
//   const { user, setUser } = useUser();


//   if (isAgentCreated === true) {
//     localStorage.setItem("agentCeated", true)
//   }
//   const hasRunRef = useRef(false);

//   const convFiredRef = useRef(false);
//   const navigate = useNavigate();
//   const { id: paramMode } = useParams();
//   const [searchParams] = useSearchParams();
//   const queryMode = searchParams.get("mode");

//   // Prefer query param if available, else fallback to URL paramm
//   const key = queryMode || paramMode;
  

//   const location = useLocation();

//   const [popupType, setPopupType] = useState(null);
//   const [popupMessage, setPopupMessage] = useState("");
//   const [message, setMessage] = useState("");

//   const [invoiceLink, setInvoiceLink] = useState("");
//   const [loading, setLoading] = useState(true);
//   // Get query params
//   const getQueryParam = (name) =>
//     new URLSearchParams(location.search).get(name);

//   const subscriptionId = getQueryParam("subscriptionId");
//   const agentId = getQueryParam("agentId");
//   const userId = getQueryParam("userId");
//   const subsid = getQueryParam("subscriptionId"); 
//   const agentName1 = getQueryParam("agentName"); 
//   const agentCode1 = getQueryParam("agentCode"); 
//   const businessName1 = getQueryParam("businessName"); 
//   const isPayg = getQueryParam("isPayg")
//   const customerId = getQueryParam("customerId")

//   const isFree = getQueryParam("isFree")
//   console.log({isFree});
  
//   const [subscriptionInfo, setSubscriptionInfo] = useState(null);
//   const [currencySymbol, setCurrencySymbol] = useState("");

//   const currentLocation = "/update";

//   const [agentName, setAgentName] = useState("Agent");
//   const [agentCode, setAgentCode] = useState("XXXXXX");
//   const [businessName, setBusinessName] = useState("Your Business");
//   const [showAnimation, setShowAnimation] = useState(false)

//   // Admin Logic
//   // near other useState hooks
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);
//   const [isLoadingRequest, setIsLoadingRequest] = useState(false);


//   const isAdmin = ((searchParams.get("isAdmin") || "").toLowerCase() === "true");

//     useEffect(() => {

       
//         // const isPayg = queryParams.get("ispayg");
//         if (isPayg) {
//             localStorage.setItem("isPayg", isPayg);
//         }
//         const storedIsPayg = localStorage.getItem("isPayg");


//         if (isPayg === "true" && storedIsPayg === "true") {

//             const activatePayg = async () => {
//                 try {
                   

                   

//                     const response = await axios.post(
//                         `${API_BASE_URL}/pay-as-you-go-saveAgent`,
//                         {
//                             customerId,
//                             agentId,
//                             status: "active",
//                             isFree: true,
//                             isByAdmin: false,
//                             isQuickSetup: true
//                         },
//                         {
//                             headers: {
//                                 Authorization: `Bearer ${token}`,
//                             },
//                         }
//                     );

//                     if (response.data.success) {
//                         // setPopupType("success");
//                         // setPopupMessage("Payment successful! Your PAYG subscription is now active.");
//                         // setShowPopup(true);

//                         window.history.replaceState({}, document.title, "/number-assign");
//                     }

//                 } catch (error) {
//                     console.error("PAYG activation error:", error.response?.data || error.message);

//                     // setPopupType("failed");
//                     // setPopupMessage("Something went wrong while activating PAYG.");
//                     // setShowPopup(true);
//                 }
//             };

//             activatePayg();
//         }

//     }, [agentId , token]);
//   const deactivateAgentSubs = async (agentId) => {
//     if (!agentId) return { ok: false, error: "agentId missing" };

//     try {

//       const resp = await fetch(`${API_BASE_URL}/admin-inactive-deffer-payments`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ agentId: agentId }),
//       });

//       const json = await resp.json();
//       if (!resp.ok) return { ok: false, error: json?.error || "Failed to deactivate" };
//       return { ok: true, data: json };
//     } catch (e) {
//       console.error("deactivateAgentSubs error:", e);
//       return { ok: false, error: "Network error" };
//     }
//   };

//   // add this function
//   const adminHandleClick = async () => {
//     try {
//       setIsButtonDisabled(true);
//       setIsLoadingRequest(true);
//       const resp = await fetch(
//         `${API_BASE_URL}/admin-checkout-user-details`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ userId }),
//         }
//       );
//       // const sessionData = getSessionData();
//       const payload1 = await resp.json();
//       const email = payload1?.data?.email;
//       const customerId = payload1?.data?.customerId;
//       const fullOtp = "notRequired";


//       if (!email || !customerId) {
//         console.warn("Missing required info to verify.");
//         return;
//       }
//       const data = await verifyOrCreateUser(email, fullOtp, customerId);

//       if (data?.res1) {
//         const verifyStatus = data?.res1?.data?.verifiedStatus === true;

//         if (verifyStatus === true) {
//           const userData = {
//             name: data?.res?.data?.user?.name || "",
//             profile:
//               `${API_BASE_URL?.split("/api")[0]}${(data?.res?.data?.profile || "").split("public")[1] || ""
//               }` || "images/camera-icon.avif",
//             subscriptionDetails: {},
//           };
//           setUser(userData)
//           // if you have a setter/context, call it here
//           localStorage.setItem("onboardComplete", "true");
//           localStorage.setItem("token", data.res?.data?.token);
//           localStorage.setItem("onboardComplete", true);
//           localStorage.setItem("paymentDone", true);
//           // localStorage.setItem("subcriptionIdUrl", subcriptionId);
//         }


//         //  Deactivate older subs with subscription_status = 9 for this agent
//         if (agentId) {
//           const deact = await deactivateAgentSubs(agentId);
//           if (!deact.ok) {
//             console.warn("Could not deactivate old deffer subscription:", deact.error);
//           }
//         }


//         navigate("/dashboard");
//         return;
//       }

//       navigate("/dashboard", { replace: true });
//     } catch (err) {
//       console.error("Error during admin verification:", err);
//     } finally {
//       setIsButtonDisabled(false);
//       setIsLoadingRequest(false);
//     }
//   };

//   const defaultHandleClick = () => {
//     if (key !== "create") {
//       localStorage.removeItem("selectedPlanData");
//       localStorage.removeItem("allPlans");
//       navigate("/dashboard", { state: { currentLocation } });
//     } else {
//       setShowAnimation(true);
//       localStorage.removeItem("selectedPlanData");
//       localStorage.removeItem("allPlans");
//       setTimeout(() => {
//         navigate("/dashboard", { replace: true });
//       }, 6000);
//     }
//   };

//   const onDashboardClick = async () => {
//     sessionStorage.removeItem("oldSubsId")
//     if (isAdmin) {
//       await adminHandleClick();
//     } else {
//       defaultHandleClick();
//     }
//   };



//   useEffect(() => {
//     const storedDashboard = sessionStorage.getItem("dashboard-session-storage");
//     const storedBusinessDetails = sessionStorage.getItem("businessDetails");
//     const storedPlaceDetails = sessionStorage.getItem("placeDetailsExtract");

//     try {
//       if (key === "update" && storedDashboard) {
//         const parsed = JSON.parse(storedDashboard);
//         const agents = parsed?.state?.agents || [];
//         const matchedAgent = agents.find((a) => a.agent_id === agentId);

//         if (matchedAgent) {
//           setAgentName(matchedAgent.agentName || "Agent");
//           setAgentCode(matchedAgent.agentCode || "XXXXXX");
//           setBusinessName(
//             matchedAgent.business?.businessName || "Your Business"
//           );
//         } else {
//           console.warn("No matching agent found for agentId:", agentId);
//         }
//       }

//       if (key === "create") {
//         let businessNameVal = "";

//         const businessData = storedBusinessDetails
//           ? JSON.parse(storedBusinessDetails)
//           : null;
//         const placeData = storedPlaceDetails
//           ? JSON.parse(storedPlaceDetails)
//           : null;

//         setAgentCode(sessionStorage.getItem("AgentCode") || "XXXXXX");
//         setAgentName(sessionStorage.getItem("agentName") || "Agent");

//         // 1. From businessDetails first
//         if (businessData) {
//           // setAgentCode(businessData.AgentCode || "XXXXXX");
//           // setAgentName(businessData.agentName || "Agent");

//           businessNameVal = businessData.businessName;
//         }

//         // 2. If missing, fallback to placeDetailsExtract
//         if (!businessNameVal && placeData?.businessName) {
//           businessNameVal = placeData.businessName;
//         }

//         setBusinessName(businessNameVal || "Your Business");
//         // ✅ Load plan details from localStorage
//         const selectedPlanRaw = localStorage.getItem("selectedPlanData");
//         if (selectedPlanRaw) {
//           try {
//             const plan = JSON.parse(selectedPlanRaw);

//             setSubscriptionInfo({
//               planName: plan.planName || "N/A",
//               planAmount: plan.price || 0,
//               planMins: plan.planMins || "N/A",
//               interval: plan.interval || "month",
//               currentPeriodStart:
//                 plan.currentPeriodStart || new Date().toISOString(),
//               nextRenewalDate: plan.nextBillingDate || null,
//               invoiceUrl: plan.invoiceUrl || null,
//             });
//           } catch (err) {
//             console.warn(
//               "Failed to parse selected plan data from localStorage:",
//               err
//             );
//           }
//         }
//       }

//       if (key === "msgPlan") {
//         // console.log("dadadsadada")
//         let aa = sessionStorage.getItem("bussinessName")
//           setAgentCode(sessionStorage.getItem("AgentCode"));
//         setAgentName(sessionStorage.getItem("agentName"));
   
//         setBusinessName(sessionStorage.getItem("bussinessName"))
//         let businessNameVal = "";

//         const businessData = storedBusinessDetails
//           ? JSON.parse(storedBusinessDetails)
//           : null;

//         // console.log("businessData",businessData);
        
//         const placeData = storedPlaceDetails
//           ? JSON.parse(storedPlaceDetails)
//           : null;

      

//         // 1. From businessDetails first
//         if (businessData) {
//           // setAgentCode(businessData.AgentCode || "XXXXXX");
//           // setAgentName(businessData.agentName || "Agent");

//           businessNameVal = businessData.businessName;
//         }

//         // 2. If missing, fallback to placeDetailsExtract
//         if (!businessNameVal && placeData?.businessName) {
//           businessNameVal = placeData.businessName;
//         }

//         // console.log("businessNameVal",businessNameVal)

//         setBusinessName(businessNameVal || "Your Business");
//         // ✅ Load plan details from localStorage
//         const selectedPlanRaw = localStorage.getItem("selectedPlanData");
//         if (selectedPlanRaw) {
//           try {
//             const plan = JSON.parse(selectedPlanRaw);

//             setSubscriptionInfo({
//               planName: plan.planName || "N/A",
//               planAmount: plan.price || 0,
//               planMins: plan.planMins || "N/A",
//               interval: plan.interval || "month",
//               currentPeriodStart:
//                 plan.currentPeriodStart || new Date().toISOString(),
//               nextRenewalDate: plan.nextBillingDate || null,
//               invoiceUrl: plan.invoiceUrl || null,
//             });
//           } catch (err) {
//             console.warn(
//               "Failed to parse selected plan data from localStorage:",
//               err
//             );
//           }
//         }
//       }
//     } catch (e) {
//       console.error("Failed to parse session storage values:", e);
//     }
//   }, [agentId, key]);
//   const cancelOldSubscription = async () => {
//     try {
//       const res = await fetch(`${API_BASE_URL}/cancel-subscription`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,

//         },
//         body: JSON.stringify({ subscriptionId: subsid }),
//       });

//       const result = await res.json();

//       if (!res.ok) {
//         console.error(
//           "❌ Failed to cancel subscription:",
//           result.error || result.message
//         );
//       } else {
//         console.log("✅ Old subscription cancelled:", result);
//       }
//     } catch (error) {
//       console.error("❌ Error cancelling subscription:", error);
//     }
//   };

//   const callNextApiAndRedirect = async () => {
  

//     try {
//       const res = await fetch(
//         `${API_BASE_URL}/agent/updateFreeAgent`,

//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ userId, agentId }),
//         }
//       );

//       const data = await res.json();

//       if (data.success) {
//         setPopupType("success");
//         setPopupMessage("Agent upgraded successfully!");
//         if (subsid) {
//           await cancelOldSubscription();
//         }
//       } else {
//         setPopupType("failed");
//         setPopupMessage("Error completing subscription.");
//       }
//     } catch (error) {
//       console.error("❌ API call failed:", error);
//       setPopupType("failed");
//       setPopupMessage("Error completing subscription.");
//     }
//   };
//   // hello
//   const fetchSubscriptionInfo = async () => {
//     if (!agentId && !userId) return; // Ensure at least one ID exists

//     try {
//       const res = await fetch(`${API_BASE_URL}/subscription-details`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(
//           agentId ? { agentId } : { userId } // Send only one key based on availability
//         ),
//       });

//       const data = await res.json();
//       // console.log("Subscription Info:", data);

//       if (data && !data.error) {
//         setSubscriptionInfo(data);
//         const currencyMap = {
//           USD: "$",
//           INR: "₹",
//           EUR: "€",
//           GBP: "£",
//           AUD: "A$",
//           CAD: "C$",
//         };
//         const upperCurrency = data.currency?.toUpperCase() || "USD";
//         const symbol = currencyMap[upperCurrency] || "$";
//         setCurrencySymbol(`${upperCurrency} ${symbol}`);
//         // Save invoice link
//         if (data.invoiceUrl) {
//           setInvoiceLink(data.invoiceUrl);
//         }
//       } else {
//         console.warn("No subscription found, falling back to static info.");
//       }
//     } catch (error) {
//       console.error("Failed to fetch subscription info:", error);
//     }
//   };

//   const formatPrice = (price) => {
//     return new Intl.NumberFormat("en-IN").format(price);
//   };



//   const fetchSubscriptionInfoMsg = async () => {
//     if (!agentId && !userId) return; // Ensure at least one ID exists

//     try {
//       const res = await fetch(`${API_BASE_URL}/subscription-details-msg`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",

//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(
//           agentId ? { agentId } : { userId } // Send only one key based on availability
//         ),
//       });

//       const data = await res.json();
//       // console.log("Subscription Info:", data);

//       if (data && !data.error) {
//         setSubscriptionInfo(data);
//         // Extract currency symbol
//         const currencyMap = {
//           USD: "$",
//           INR: "₹",
//           EUR: "€",
//           GBP: "£",
//           AUD: "A$",
//           CAD: "C$",
//         };
//         const upperCurrency = data.currency?.toUpperCase() || "USD";
//         const symbol = currencyMap[upperCurrency] || "$";
//         setCurrencySymbol(`${upperCurrency} ${symbol}`);
//         // Save invoice link
//         if (data.invoiceUrl) {
//           setInvoiceLink(data.invoiceUrl);
//         }
//       } else {
//         console.warn("No subscription found, falling back to static info.");
//       }
//     } catch (error) {
//       console.error("Failed to fetch subscription info:", error);
//     }
//   };


//   useEffect(() => {
//     // console.log("dddddddddd");


//     if (hasRunRef.current) return;
//     hasRunRef.current = true;

//     const hasHandledThankYou = localStorage.getItem("hasHandledThankYou");

//     localStorage.setItem("hasHandledThankYou", "true");
//     // console.log("hasHandledThankYou", hasHandledThankYou)

//     const shouldRunUpdateAgent = key === "update" && agentId && userId;
//     const shouldRunWithStripeFlow = subscriptionId && agentId && userId;
//     const shouldRunCreateFlow = key === "create" && userId;

//     const shouldMsgCheck = key === "msgPlan"
//     // console.log(shouldMsgCheck, "gashas");

// const cancelOldSubscription = async () => {
//   try {
//     let subscriptionId = sessionStorage.getItem("oldSubsId")
//     if (!subscriptionId) throw new Error("subscriptionId is required");

//     // Call your backend cancel API
//     const response = await axios.post(`${API_BASE_URL}/cancelMessage-plan`, {
//       subscriptionId,
//     });

//     // console.log("Cancel response:", response.data);

  
//   } catch (error) {
//     console.error("Error canceling subscription:", error);
   
//   }
// };

//     const run = async () => {
//       try {
//         setLoading(true);
//         if (shouldMsgCheck) {
//           // console.log("doneeeee this workkkk");

//           await new Promise((resolve) => setTimeout(resolve, 1500));
         
//            let subscriptionId = sessionStorage.getItem("oldSubsId")
//           if(subscriptionId){
//   await cancelOldSubscription()
//   await fetchSubscriptionInfoMsg();
 
//           }
//           else{
//        await fetchSubscriptionInfoMsg();
//           }
         
//         }
//         else if (shouldRunWithStripeFlow || shouldRunUpdateAgent) {
//           await callNextApiAndRedirect(); 
//           await new Promise((resolve) => setTimeout(resolve, 1500));
//           await fetchSubscriptionInfo();
//         } else if (shouldRunCreateFlow) {
//           await new Promise((resolve) => setTimeout(resolve, 1500));
//           await fetchSubscriptionInfo();
//           if (!hasHandledThankYou) {
//             onSubmit();
//           }
//           // else if (shouldMsgCheck) {
//           //   console.log("doneeeee this workkkk");

//           //   await new Promise((resolve) => setTimeout(resolve, 1500));
//           //   await fetchSubscriptionInfoMsg();
//           // }
//         }
//       } catch (error) {
//         console.log(error);
//       } finally {
//         setLoading(false); // 🔁 Now it happens *after* data fetch
//       }
//     };

//     run();
//   }, [key, subscriptionId, agentId, userId, subsid, isAdmin]);

//   const formatCurrency = (amount, currency) => {
//     const upperCurrency = currency?.toUpperCase() || "USD";

//     const symbolMap = {
//       USD: "$",
//       INR: "₹",
//       EUR: "€",
//       GBP: "£",
//       AUD: "A$",
//       CAD: "C$",
//       // Add more if needed
//     };

//     const symbol = symbolMap[upperCurrency] || "";

//     return `${upperCurrency} ${symbol}${Number(amount).toLocaleString()}`;
//   };
//   useEffect(() => {
//     fetch("/animations/Lottie_Loader.json")
//       .then((res) => res.json())
//       .then((data) => setAnimationData(data))
//       .catch((err) => console.error("Error loading animation:", err));
//   }, []);
//   useEffect(() => {
//     if (loading || !subscriptionInfo) return; 
//     if (convFiredRef.current) return; 
//     if (typeof window.gtag !== "function") return; 

//     window.gtag("event", "conversion", {
//       send_to: "AW-17437749926/M6gmCJzi-v8aEKbl-_pA",
//       value: Number(subscriptionInfo.planAmount || 1.0),
//       currency: (subscriptionInfo.currency || "USD").toUpperCase(),
//       transaction_id:
//         subscriptionInfo.subscriptionId ||
//         `${userId || "uid"}-${Date.now()}`, 
//     });
//     convFiredRef.current = true;
//   }, [loading, subscriptionInfo, subscriptionId, userId]);
//   return (

//     <>

//       {showAnimation ?
//         <>
//           <div className={styles.container}>
//             <br /> <br />
//             <div className={styles.Logo}>
//               <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
//             </div>
//           </div>
//           <div className={styles.animationContainer}>
//             <div className={styles.animationContent}>
//               <LottieAnimation animationData={animationData} width={300} height={300} />
//               <p className={styles.loaderText}><b>Setting up your agent... </b><br /><br /> Please Wait</p>
//             </div>

//           </div>
//         </>

//         :
//         subscriptionInfo ? <div>
//           <div className={styles.container}>
//             <div className={styles.Logo}>
//               <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
//             </div>

//             <div className={styles.ThankyouMsg}>
//               <div className={styles.title}>Thanks!</div>
//               <div className={styles.subtitle}>for your Purchase</div>
//               <p className={styles.description}>
//                 Your payment was successful. We’ve sent you a confirmation email
//                 with all the details you need.
//               </p>
//             </div>

//             {loading ? (
//               <Loader2 />
//             ) : (
//               <div className={styles.infoBox}>
//                 <p>Below is some Quick Info for your Reference:</p>
//                 <div className={styles.row}>
//                   <span>Business Name:</span>{" "}
//                   <div className={styles.Right50}>
//                     {isAdmin ? businessName1 : (key === "msgPlan" ? sessionStorage.getItem("bussinessName") :  businessName || "ACME Construction Services")}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Agent Name & ID:</span>
//                   <div className={styles.Right50}>
//                     {isAdmin
//                       ? agentName1 && agentCode1
//                         ? `${agentName1} (${agentCode1})`
//                         : "Oliver (HS23D4)"
//                       : agentName && agentCode
//                         ? `${agentName} (${agentCode})`
//                         : "Oliver (HS23D4)"}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Plan Activated:</span>
//                   <div className={styles.Right50}>
//                     {subscriptionInfo?.planName || "Growth"} -{" "}
//                     { key === "msgPlan" ? subscriptionInfo.planMessage : subscriptionInfo?.planMins|| "1500" } 
//                     {key === "msgPlan" ?  " Messages" : " Minutes"}
//                   </div>
//                 </div>
//                 <div className={styles.row}>
//                   <span>Frequency & Price:</span>
//                   <div className={styles.Right50}>
//   {isFree === "true" ? (
//     "US $299 / month"
//   ) : subscriptionInfo ? (
//     `${currencySymbol}${formatPrice(
//       subscriptionInfo?.metadata?.original_plan_amount
//     )} / ${subscriptionInfo.interval}`
//   ) : (
//     "US $499 / month"
//   )}
// </div>

//                 </div>
//                 {/* <div className={styles.row}>
//             <span>Discount Applied:</span>
//             <div className={styles.Right50}>N/A</div>
//           </div> */}
//                 <div className={styles.row}>
//                   <span>Billed Today:</span>
//                   <div className={styles.Right50}>
//                     {subscriptionInfo ? (
//                       <>
//                         {`${currencySymbol}${formatPrice(
//                           subscriptionInfo.planAmount
//                         )} on `}
//                         {new Date(
//                           subscriptionInfo.currentPeriodStart
//                         ).toLocaleDateString("en-US", {
//                           year: "numeric",
//                           month: "long",
//                           day: "numeric",
//                         })}
//                       </>
//                     ) : (
//                       "$5,688.60 on July 12, 2025"
//                     )}
//                   </div>
//                 </div>

//                 <div className={styles.row}>
//                   <span>Next Billing Date:</span>
//                   <div className={styles.Right50}>
//   {subscriptionInfo ? (
//     isFree === "true" ? (
//       // FREE → currentPeriodStart + 7 days
//       new Date(
//         new Date(subscriptionInfo.currentPeriodStart).getTime() +
//           7 * 24 * 60 * 60 * 1000
//       ).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     ) : (
//       // NOT FREE → show nextRenewalDate
//       new Date(subscriptionInfo.nextRenewalDate).toLocaleDateString("en-US", {
//         year: "numeric",
//         month: "long",
//         day: "numeric",
//       })
//     )
//   ) : (
//     "06 July 2026"
//   )}
// </div>

//                 </div>
//                 {invoiceLink && (
//                   <div className={styles.row}>
//                     <span>Invoice Link:</span>
//                     <div className={styles.Right50}>
//                       <a
//                         href={invoiceLink}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className={styles.downloadButton}
//                         style={{
//                           color: "purple",
//                           textDecoration: "none",
//                           cursor: "pointer",
//                         }}
//                         download
//                       >
//                         Download
//                       </a>
//                     </div>
//                   </div>
//                 )}

//                 <div className={styles.ButtonTakeME}>
//                   <button
//                     onClick={onDashboardClick}
//                     className={styles.dashboardBtn}
//                     disabled={isButtonDisabled || isLoadingRequest || (key === "create" ? !isAgentCreated : false)}
//                   >
//                     {isLoadingRequest
//                       ? "Redirecting..."
//                       : key === "create"
//                         ? (isAgentCreated ? "Take me to Dashboard" : "Thinking...")
//                         : "Take me to Dashboard"}
//                   </button>

//                 </div>
//               </div>
//             )}
//           </div>
//         </div> : <Loader2 />}



//     </>
//   );
// }

// export default Thankyou;

import React, { useEffect, useState } from "react";
import styles from "./Thankyou.module.css";
import {
  useNavigate,
  useParams,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import {
  API_BASE_URL,
  token,
  verifyOrCreateUser,
  // getAgentById eager-loads the `business` association, so a single
  // call covers both agent + business needs on this page.
  getAgentById,
} from "../../Store/apiStore";
import { useRef } from "react";
import Loader2 from "../Loader2/Loader2";
import LottieAnimation from "../../lib/LottieAnimation";
import useUser from "../../Store/Context/UserContext";
import axios from "axios";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import AnimatedButton2 from "../AnimatedButton/AnimatedButton2";

function Thankyou({ onSubmit, isAgentCreated }) {
  const [animationData, setAnimationData] = useState(null);
  const { user, setUser } = useUser();

  if (isAgentCreated === true) {
    localStorage.setItem("agentCeated", true);
  }

  const hasRunRef = useRef(false);
  const convFiredRef = useRef(false);
  // Idempotency for the post-purchase auth bootstrap below — strict
  // mode double-mounts would otherwise hit /admin-checkout-user-details
  // twice and call verifyOrCreateUser twice (idempotent server-side,
  // but wasteful + log-noisy).
  const postPurchaseBootstrapRef = useRef(false);
  const autoLoginRunRef = useRef(false);
  // Idempotency for the post-purchase Sophia Setup Score mark — same
  // +20 pts planActivated bump that GoLiveWizard fires for the regular
  // /recommended-plan checkout. We mark it here for the LP-trial path
  // because that flow's success URL skips /go-live-setup entirely.
  const postPurchaseScoreMarkedRef = useRef(false);
  const navigate = useNavigate();
  const { id: paramMode } = useParams();
  const [searchParams] = useSearchParams();
  const queryMode = searchParams.get("mode");
  const key = queryMode || paramMode;

  const location = useLocation();

  const [popupType, setPopupType] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
  const [message, setMessage] = useState("");
  const [invoiceLink, setInvoiceLink] = useState("");
  const [loading, setLoading] = useState(true);

  const getQueryParam = (name) =>
    new URLSearchParams(location.search).get(name);

  const subscriptionId = getQueryParam("subscriptionId");
  const agentId        = getQueryParam("agentId");
  const userId         = getQueryParam("userId");
  const subsid         = getQueryParam("subscriptionId");
  const agentName1     = getQueryParam("agentName");
  const agentCode1     = getQueryParam("agentCode");
  const businessName1  = getQueryParam("businessName");
  const isPayg         = getQueryParam("isPayg");
  const customerId     = getQueryParam("customerId");
  const isFree         = getQueryParam("isFree");
  const autoLogin      = getQueryParam("autoLogin") === "true";
  // postPurchase=true is set by the LP-demo PaymentPage's buildSuccessUrl
  // — its presence means the visitor already has an agent (built during
  // the LP demo) and should be routed into the /post-purchase-setup
  // wizard after Thank You instead of straight to /dashboard.
  const isPostPurchase = getQueryParam("postPurchase") === "true";
  /*
   * Forward Thankyou's `personalDetails=true` flag onto the
   * /post-purchase-setup URL. The wizard reads it on mount to decide
   * whether to include Step 2 (Personal Details) in its STEPS array.
   *
   * Belt-and-braces: we ALSO stash the flag into sessionStorage so
   * the wizard can read it even if URL forwarding gets dropped by
   * an intermediate redirect / replaceState somewhere. The wizard's
   * boot effect clears the sessionStorage entry once consumed.
   */
  const wantPersonalDetails = getQueryParam("personalDetails") === "true";
  const postPurchaseTarget = wantPersonalDetails
    ? "/post-purchase-setup?personalDetails=true"
    : "/post-purchase-setup";

  useEffect(() => {
    console.log("[Thankyou DEBUG] mount-time check", {
      url: window.location.href,
      wantPersonalDetails,
      isPostPurchase,
      postPurchaseTarget,
    });
    if (wantPersonalDetails) {
      try {
        sessionStorage.setItem(
          "postPurchaseSetup.showPersonalDetails",
          "true",
        );
        console.log(
          "[Thankyou DEBUG] sessionStorage.postPurchaseSetup.showPersonalDetails set to 'true'",
        );
      } catch (e) {
        console.warn("[Thankyou DEBUG] sessionStorage write failed:", e);
      }
    } else {
      console.log(
        "[Thankyou DEBUG] wantPersonalDetails is FALSE — Personal Details will be skipped",
      );
    }
  }, [wantPersonalDetails]);

  console.log({ isFree, isPostPurchase, wantPersonalDetails });

  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState("");

  const currentLocation = "/update";

  const [agentName, setAgentName]         = useState("Agent");
  const [agentCode, setAgentCode]         = useState("XXXXXX");
  const [businessName, setBusinessName]   = useState("Your Business");
  const [showAnimation, setShowAnimation] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);

  const isAdmin = ((searchParams.get("isAdmin") || "").toLowerCase() === "true");

  // ─────────────────────────────────────────
  // isPayg date helpers
  // ─────────────────────────────────────────
  const paygBilledDate = new Date();
  const paygNextBillingDate = new Date(paygBilledDate);
  paygNextBillingDate.setMonth(paygNextBillingDate.getMonth() + 1);

  const formatDate = (date) =>
    date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  // Resolution order:
  //   1. PostPurchase variant: prefer state set by the agent-fetch effect
  //      (real DB values for the matched agentId).
  //   2. Admin path: URL query params (businessName1, agentName1, agentCode1).
  //   3. Non-admin: locally-set state.
  //   4. Final placeholder fallback.
  // This stops the Quick Info from rendering "Oliver (HS23D4)" / "Your
  // Business" placeholders when the post-purchase URL only carries
  // agentId + userId.
  const displayAgentName = isPostPurchase
    ? agentName || agentName1 || "Agent"
    : isAdmin
    ? agentName1 || "Agent"
    : agentName || "Agent";

  const displayAgentCode = isPostPurchase
    ? agentCode || agentCode1 || "XXXXXX"
    : isAdmin
    ? agentCode1 || "XXXXXX"
    : agentCode || "XXXXXX";

  const displayBusinessName = isPostPurchase
    ? businessName || businessName1 || "Your Business"
    : isAdmin
    ? businessName1 || "Your Business"
    : businessName || "Your Business";

  // ─────────────────────────────────────────
  // PAYG Activation — ✅ route change NAHI hoga
  // sirf API call hogi background mein
  // ─────────────────────────────────────────
  useEffect(() => {
    if (isPayg) {
      localStorage.setItem("isPayg", isPayg);
    }
    const storedIsPayg = localStorage.getItem("isPayg");

    if (isPayg === "true" && storedIsPayg === "true") {
      const activatePayg = async () => {
        try {
          const response = await axios.post(
            `${API_BASE_URL}/pay-as-you-go-saveAgent`,
            {
              customerId,
              agentId,
              status: "active",
              isFree: true,
              isByAdmin: false,
              isQuickSetup: true,
            },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          // ✅ window.history.replaceState HATA DIYA
          // Route change sirf button click pe hoga
          if (response.data.success) {
            console.log("PAYG activated successfully");
          }
        } catch (error) {
          console.error("PAYG activation error:", error.response?.data || error.message);
        }
      };

      activatePayg();
    }
  }, [agentId, token]);

  const deactivateAgentSubs = async (agentId) => {
    if (!agentId) return { ok: false, error: "agentId missing" };
    try {
      const resp = await fetch(`${API_BASE_URL}/admin-inactive-deffer-payments`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ agentId }),
      });
      const json = await resp.json();
      if (!resp.ok) return { ok: false, error: json?.error || "Failed to deactivate" };
      return { ok: true, data: json };
    } catch (e) {
      console.error("deactivateAgentSubs error:", e);
      return { ok: false, error: "Network error" };
    }
  };

  const adminHandleClick = async () => {
    try {
      setIsButtonDisabled(true);
      setIsLoadingRequest(true);
      const resp = await fetch(`${API_BASE_URL}/admin-checkout-user-details`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
      const payload1   = await resp.json();
      const email      = payload1?.data?.email;
      const customerId = payload1?.data?.customerId;
      const fullOtp    = "notRequired";

      if (!email || !customerId) {
        console.warn("Missing required info to verify.");
        return;
      }

      const data = await verifyOrCreateUser(email, fullOtp, customerId);

      if (data?.res1) {
        const verifyStatus = data?.res1?.data?.verifiedStatus === true;
        if (verifyStatus === true) {
          const userData = {
            name: data?.res?.data?.user?.name || "",
            profile:
              `${API_BASE_URL?.split("/api")[0]}${(data?.res?.data?.profile || "").split("public")[1] || ""}` ||
              "images/camera-icon.avif",
            subscriptionDetails: {},
          };
          setUser(userData);
          localStorage.setItem("onboardComplete", "true");
          // Truthy guard — earlier `setItem("token", undefined)` would
          // write the literal string "undefined" into localStorage,
          // which then became `Authorization: Bearer undefined` on
          // every subsequent API call → 401 → auth guard bounced the
          // visitor to /signup. Keep the previous valid token if the
          // new response didn't include one (rare server hiccup).
          const newToken = data.res?.data?.token;
          if (newToken) {
            localStorage.setItem("token", newToken);
          }
          localStorage.setItem("paymentDone", true);
        }

        if (agentId) {
          const deact = await deactivateAgentSubs(agentId);
          if (!deact.ok) {
            console.warn("Could not deactivate old deffer subscription:", deact.error);
          }
        }

        // Routing precedence:
        //  1. postPurchase=true (LP-demo paid)  → /post-purchase-setup
        //     wizard. Marks paymentDone so the wizard's own boot guard
        //     allows the visit through, and stashes the agent_id so
        //     wizard steps can fetch business details / phone numbers.
        //  2. isPayg=true                       → /number-assign (existing)
        //  3. default                           → /dashboard (existing)
        if (isPostPurchase) {
          localStorage.setItem("paymentDone", "true");
          if (agentId) {
            sessionStorage.setItem("SelectAgentId", agentId);
            localStorage.setItem("postPurchaseAgentId", agentId);
          }
          navigate(postPurchaseTarget, { replace: true });
        } else if (isPayg === "true") {
          navigate("/number-assign");
        } else {
          navigate("/fast-agent-detail");
        }
        return;
      }
      navigate("/fast-agent-detail", { replace: true });
    } catch (err) {
      console.error("Error during admin verification:", err);
    } finally {
      setIsButtonDisabled(false);
      setIsLoadingRequest(false);
    }
  };

  const defaultHandleClick = async () => {
    // Same postPurchase short-circuit for the non-admin path. Keeps the
    // existing key === "create" animation flow intact for everyone else.
    if (isPostPurchase) {
      // Click-time fallback for the post-purchase auth bootstrap above:
      // if the mount-time bootstrap is still in-flight (or failed) and
      // we still don't have a usable token, run the same admin-style
      // verify flow synchronously NOW so /post-purchase-setup doesn't
      // bounce the visitor to /signup. Doesn't touch the legacy
      // admin / paid / payg / msgPlan code paths.
      const t = localStorage.getItem("token");
      const tokenMissing = !t || t === "undefined" || t === "null";
      if (tokenMissing && userId) {
        try {
          await adminHandleClick();
          // adminHandleClick navigates internally on success — exit here
          // to avoid double navigation.
          return;
        } catch (e) {
          console.error("[Thankyou] defaultHandleClick fallback bootstrap failed:", e);
          // Fall through to existing nav so visitor isn't stranded
        }
      }

      localStorage.setItem("paymentDone", "true");
      if (agentId) {
        sessionStorage.setItem("SelectAgentId", agentId);
        localStorage.setItem("postPurchaseAgentId", agentId);
      }
      localStorage.removeItem("selectedPlanData");
      localStorage.removeItem("allPlans");
      navigate(postPurchaseTarget, { replace: true });
      return;
    }

    // Non-admin paid users land on the single-agent fast detail page,
    // NOT the multi-agent /dashboard (which is the admin / legacy
    // workspace). Admin path in adminHandleClick still routes to
    // /dashboard since admins manage multiple users from there.
    if (key !== "create") {
      localStorage.removeItem("selectedPlanData");
      localStorage.removeItem("allPlans");
      navigate("/fast-agent-detail", { state: { currentLocation } });
    } else {
      setShowAnimation(true);
      localStorage.removeItem("selectedPlanData");
      localStorage.removeItem("allPlans");
      setTimeout(() => {
        navigate("/fast-agent-detail", { replace: true });
      }, 6000);
    }
  };

  const onDashboardClick = async () => {
    sessionStorage.removeItem("oldSubsId");
    if (isAdmin) {
      await adminHandleClick();
    } else {
      defaultHandleClick();
    }
  };

  useEffect(() => {
    if (!autoLogin || !isAdmin || !userId) return;
    if (autoLoginRunRef.current) return;
    autoLoginRunRef.current = true;
    onDashboardClick();
  }, [autoLogin, isAdmin, userId]);

  // Post-purchase variant — fetch agent + business in ONE call so the
  // Quick Info box shows the real "Business Name" + "Agent Name & ID"
  // instead of the hardcoded "Oliver (HS23D4)" fallback. The backend
  // getAgentById eager-loads the `business` association, so a single
  // round-trip gives us both. Other Thankyou entry paths
  // (key === "create" / "update" / "msgPlan") already have their own
  // data sources further down — we don't touch those.
  useEffect(() => {
    if (!isPostPurchase) return;
    if (!agentId) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await getAgentById(agentId);
        console.log("[Thankyou] getAgentById raw response:", res);
        const agent = res?.data || res || {};
        console.log("[Thankyou] agent extracted:", agent);
        console.log("[Thankyou] agent.business:", agent?.business);
        console.log("[Thankyou] agent.businessId:", agent?.businessId);
        if (cancelled) return;

        if (agent?.agentName) setAgentName(agent.agentName);
        if (agent?.agentCode) setAgentCode(agent.agentCode);

        const biz = agent?.business;
        const bizName =
          biz?.businessName ||
          biz?.googleBusinessName ||
          "";
        console.log("[Thankyou] resolved businessName:", bizName);
        if (bizName) setBusinessName(bizName);

        // Pull real subscription info too — without this the Plan
        // Activated row falls back to the (now-removed) "Growth - 1500"
        // hardcode and stays blank. The main useEffect's
        // fetchSubscriptionInfo path is gated on subscriptionId/key
        // params that postPurchase URLs don't carry, so we fetch here.
        // Best-effort: token may not be ready yet (the auth bootstrap
        // effect below seeds it shortly after mount), so we wait a beat
        // and then fetch.
        const fetchSub = async () => {
          try {
            const t = localStorage.getItem("token");
            if (!t || t === "undefined" || t === "null") return false;
            const sres = await fetch(
              `${API_BASE_URL}/subscription-details`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${t}`,
                },
                body: JSON.stringify({ agentId }),
              }
            );
            const sdata = await sres.json();
            if (cancelled) return true;
            if (sdata && !sdata.error) {
              setSubscriptionInfo(sdata);
              const currencyMap = {
                USD: "$",
                INR: "₹",
                EUR: "€",
                GBP: "£",
                AUD: "A$",
                CAD: "C$",
              };
              const upperCurrency =
                sdata.currency?.toUpperCase() || "USD";
              setCurrencySymbol(
                `${upperCurrency} ${currencyMap[upperCurrency] || "$"}`
              );
              if (sdata.invoiceUrl) setInvoiceLink(sdata.invoiceUrl);
            }
            return true;
          } catch (e) {
            console.warn(
              "[Thankyou] postPurchase subscription fetch failed:",
              e?.message || e
            );
            return true; // give up after one shot once token exists
          }
        };

        // Try once now — works if user is already authed. Otherwise
        // poll every 500ms (max ~10s) waiting for the auth bootstrap.
        if (!(await fetchSub())) {
          let attempts = 0;
          const id = setInterval(async () => {
            if (cancelled) {
              clearInterval(id);
              return;
            }
            const done = await fetchSub();
            if (done || ++attempts >= 20) clearInterval(id);
          }, 500);
        }
      } catch (err) {
        console.error("[Thankyou] postPurchase fetch failed:", err);
        // Non-fatal — Quick Info row simply hides if names stay blank.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isPostPurchase, agentId]);

  // ── Post-purchase auth bootstrap (guest → authenticated) ────────────
  //
  // Why: visitors who arrive here from the LP-demo Stripe checkout
  // don't have a token in localStorage yet (they were guests during
  // checkout, and Stripe's webhook creates the user row server-side).
  // Earlier the page just rendered without a token, App.js would log
  // "No token provided" repeatedly, and pressing "Take me to Dashboard"
  // navigated to a guarded route → auth guard bounced them to /signup.
  //
  // Behavior is STRICTLY GATED so the legacy admin / regular-paid /
  // PAYG / msgPlan / update flows are not affected:
  //   - Only fires when `postPurchase=true` query param is present
  //   - Only fires when localStorage has no usable token already
  //   - Only fires when userId is present in URL
  //   - Once-per-mount via ref guard (strict-mode safe)
  //
  // This silently fetches email + customerId via the same admin
  // endpoint adminHandleClick uses, then verifyOrCreateUser to obtain
  // a real token. By the time the user clicks the dashboard CTA the
  // token is already in localStorage and downstream guards pass.
  useEffect(() => {
    if (!isPostPurchase) return;
    if (!userId) return;
    if (postPurchaseBootstrapRef.current) return;
    const existingToken = localStorage.getItem("token");
    // Treat "undefined" / "null" literal strings as missing — earlier
    // bug was writing those literals which then poisoned auth headers.
    if (existingToken && existingToken !== "undefined" && existingToken !== "null") {
      return;
    }

    postPurchaseBootstrapRef.current = true;
    (async () => {
      try {
        console.log("[Thankyou] Bootstrapping auth for post-purchase guest user");
        const resp = await fetch(`${API_BASE_URL}/admin-checkout-user-details`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId }),
        });
        const payload = await resp.json();
        const email = payload?.data?.email;
        const customerId = payload?.data?.customerId;
        if (!email || !customerId) {
          console.warn("[Thankyou] Bootstrap missing email/customerId — skipping");
          return;
        }
        const data = await verifyOrCreateUser(email, "notRequired", customerId);
        const newToken = data?.res?.data?.token;
        if (newToken) {
          localStorage.setItem("token", newToken);
          localStorage.setItem("paymentDone", "true");
          localStorage.setItem("onboardComplete", "true");
          // Also hydrate user context so navbar / profile pic render
          // correctly without a hard refresh after navigation.
          try {
            setUser({
              name: data?.res?.data?.user?.name || "",
              profile:
                `${API_BASE_URL?.split("/api")[0]}${(data?.res?.data?.profile || "").split("public")[1] || ""}` ||
                "images/camera-icon.avif",
              subscriptionDetails: {},
            });
          } catch {}
          console.log("[Thankyou] Auth bootstrap successful — token stored");
        } else {
          console.warn("[Thankyou] Bootstrap response had no token");
        }
      } catch (err) {
        console.error("[Thankyou] Auth bootstrap failed:", err.message || err);
        // Non-fatal — defaultHandleClick has its own fallback below
      }
    })();
  }, [isPostPurchase, userId]);

  // ── Post-purchase Sophia Setup Score mark (+20 pts, planActivated) ──
  //
  // Mirrors GoLiveWizard's /onboarding/pricing/activated call. The LP
  // /fb/home-service-click trial pays $20 → Stripe success → here, but
  // it skips /go-live-setup, so without this effect the planActivated
  // step would never get the +20 bump and the score would stall at the
  // pre-payment value.
  //
  // Polls for the token (the bootstrap effect above seeds it on the
  // first render, but as a guest the very first paint may not have it
  // yet). Caps at 10 attempts (≈5s) so a missing token doesn't leave
  // the interval running forever. Idempotent on the server.
  useEffect(() => {
    if (!isPostPurchase) return;
    if (!agentId) return;
    if (postPurchaseScoreMarkedRef.current) return;

    let cancelled = false;
    let attempts = 0;

    const tryMark = async () => {
      if (cancelled || postPurchaseScoreMarkedRef.current) return true;
      const token = localStorage.getItem("token");
      if (!token || token === "undefined" || token === "null") return false;
      postPurchaseScoreMarkedRef.current = true;
      try {
        await fetch(`${API_BASE_URL}/onboarding/pricing/activated`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            agentId,
            planTier: "trial_21day",
            billingInterval: "monthly",
            claimedFreeTrial: true,
          }),
        });
      } catch (err) {
        console.warn(
          "[Thankyou] postPurchase score mark failed:",
          err?.message || err
        );
      }
      return true;
    };

    // Try immediately, then poll until the bootstrap seeds the token.
    tryMark();
    const interval = setInterval(async () => {
      if (cancelled) return;
      const done = await tryMark();
      if (done || ++attempts >= 10) clearInterval(interval);
    }, 500);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [isPostPurchase, agentId]);

  useEffect(() => {
    const storedDashboard       = sessionStorage.getItem("dashboard-session-storage");
    const storedBusinessDetails = sessionStorage.getItem("businessDetails");
    const storedPlaceDetails    = sessionStorage.getItem("placeDetailsExtract");

    try {
      if (key === "update" && storedDashboard) {
        const parsed       = JSON.parse(storedDashboard);
        const agents       = parsed?.state?.agents || [];
        const matchedAgent = agents.find((a) => a.agent_id === agentId);
        if (matchedAgent) {
          setAgentName(matchedAgent.agentName || "Agent");
          setAgentCode(matchedAgent.agentCode || "XXXXXX");
          setBusinessName(matchedAgent.business?.businessName || "Your Business");
        } else {
          console.warn("No matching agent found for agentId:", agentId);
        }
      }

      if (key === "create") {
        let businessNameVal = "";
        const businessData  = storedBusinessDetails ? JSON.parse(storedBusinessDetails) : null;
        const placeData     = storedPlaceDetails    ? JSON.parse(storedPlaceDetails)    : null;

        setAgentCode(sessionStorage.getItem("AgentCode") || "XXXXXX");
        setAgentName(sessionStorage.getItem("agentName") || "Agent");

        if (businessData) businessNameVal = businessData.businessName;
        if (!businessNameVal && placeData?.businessName) businessNameVal = placeData.businessName;
        setBusinessName(businessNameVal || "Your Business");

        const selectedPlanRaw = localStorage.getItem("selectedPlanData");
        if (selectedPlanRaw) {
          try {
            const plan = JSON.parse(selectedPlanRaw);
            setSubscriptionInfo({
              planName:            plan.planName   || "N/A",
              planAmount:          plan.price      || 0,
              planMins:            plan.planMins   || "N/A",
              interval:            plan.interval   || "month",
              currentPeriodStart:  plan.currentPeriodStart || new Date().toISOString(),
              nextRenewalDate:     plan.nextBillingDate    || null,
              invoiceUrl:          plan.invoiceUrl         || null,
            });
          } catch (err) {
            console.warn("Failed to parse selected plan data from localStorage:", err);
          }
        }
      }

      if (key === "msgPlan") {
        setAgentCode(sessionStorage.getItem("AgentCode"));
        setAgentName(sessionStorage.getItem("agentName"));
        setBusinessName(sessionStorage.getItem("bussinessName"));

        let businessNameVal = "";
        const businessData  = storedBusinessDetails ? JSON.parse(storedBusinessDetails) : null;
        const placeData     = storedPlaceDetails    ? JSON.parse(storedPlaceDetails)    : null;

        if (businessData) businessNameVal = businessData.businessName;
        if (!businessNameVal && placeData?.businessName) businessNameVal = placeData.businessName;
        setBusinessName(businessNameVal || "Your Business");

        const selectedPlanRaw = localStorage.getItem("selectedPlanData");
        if (selectedPlanRaw) {
          try {
            const plan = JSON.parse(selectedPlanRaw);
            setSubscriptionInfo({
              planName:           plan.planName  || "N/A",
              planAmount:         plan.price     || 0,
              planMins:           plan.planMins  || "N/A",
              interval:           plan.interval  || "month",
              currentPeriodStart: plan.currentPeriodStart || new Date().toISOString(),
              nextRenewalDate:    plan.nextBillingDate    || null,
              invoiceUrl:         plan.invoiceUrl         || null,
            });
          } catch (err) {
            console.warn("Failed to parse selected plan data from localStorage:", err);
          }
        }
      }
    } catch (e) {
      console.error("Failed to parse session storage values:", e);
    }
  }, [agentId, key]);

  const cancelOldSubscription = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/cancel-subscription`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ subscriptionId: subsid }),
      });
      const result = await res.json();
      if (!res.ok) {
        console.error("Failed to cancel subscription:", result.error || result.message);
      } else {
        console.log("Old subscription cancelled:", result);
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error);
    }
  };

  const callNextApiAndRedirect = async () => {
    try {
      const res  = await fetch(`${API_BASE_URL}/agent/updateFreeAgent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, agentId }),
      });
      const data = await res.json();
      if (data.success) {
        setPopupType("success");
        setPopupMessage("Agent upgraded successfully!");
        if (subsid) await cancelOldSubscription();
      } else {
        setPopupType("failed");
        setPopupMessage("Error completing subscription.");
      }
    } catch (error) {
      console.error("API call failed:", error);
      setPopupType("failed");
      setPopupMessage("Error completing subscription.");
    }
  };

  const fetchSubscriptionInfo = async () => {
    if (!agentId && !userId) return;
    try {
      const res  = await fetch(`${API_BASE_URL}/subscription-details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(agentId ? { agentId } : { userId }),
      });
      const data = await res.json();
      if (data && !data.error) {
        setSubscriptionInfo(data);
        const currencyMap   = { USD: "$", INR: "₹", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$" };
        const upperCurrency = data.currency?.toUpperCase() || "USD";
        setCurrencySymbol(`${upperCurrency} ${currencyMap[upperCurrency] || "$"}`);
        if (data.invoiceUrl) setInvoiceLink(data.invoiceUrl);
      } else {
        console.warn("No subscription found, falling back to static info.");
      }
    } catch (error) {
      console.error("Failed to fetch subscription info:", error);
    }
  };

  const formatPrice = (price) => new Intl.NumberFormat("en-IN").format(price);

  const fetchSubscriptionInfoMsg = async () => {
    if (!agentId && !userId) return;
    try {
      const res  = await fetch(`${API_BASE_URL}/subscription-details-msg`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(agentId ? { agentId } : { userId }),
      });
      const data = await res.json();
      if (data && !data.error) {
        setSubscriptionInfo(data);
        const currencyMap   = { USD: "$", INR: "₹", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$" };
        const upperCurrency = data.currency?.toUpperCase() || "USD";
        setCurrencySymbol(`${upperCurrency} ${currencyMap[upperCurrency] || "$"}`);
        if (data.invoiceUrl) setInvoiceLink(data.invoiceUrl);
      } else {
        console.warn("No subscription found, falling back to static info.");
      }
    } catch (error) {
      console.error("Failed to fetch subscription info:", error);
    }
  };

  // ─────────────────────────────────────────
  // ✅ Main useEffect — isPayg ke liye bhi
  // saari APIs chalti raheingi — koi early return nahi   xx
  // ─────────────────────────────────────────
  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const hasHandledThankYou = localStorage.getItem("hasHandledThankYou");
    localStorage.setItem("hasHandledThankYou", "true");

    const shouldRunUpdateAgent    = key === "update" && agentId && userId;
    const shouldRunWithStripeFlow = subscriptionId && agentId && userId;
    const shouldRunCreateFlow     = key === "create" && userId;
    const shouldMsgCheck          = key === "msgPlan";

    const cancelOldSubscriptionMsg = async () => {
      try {
        let subscriptionId = sessionStorage.getItem("oldSubsId");
        if (!subscriptionId) throw new Error("subscriptionId is required");
        await axios.post(`${API_BASE_URL}/cancelMessage-plan`, { subscriptionId });
      } catch (error) {
        console.error("Error canceling subscription:", error);
      }
    };

    const run = async () => {
      try {
        setLoading(true);
        if (shouldMsgCheck) {
          await new Promise((resolve) => setTimeout(resolve, 1500));
          const subscriptionId = sessionStorage.getItem("oldSubsId");
          if (subscriptionId) {
            await cancelOldSubscriptionMsg();
            await fetchSubscriptionInfoMsg();
          } else {
            await fetchSubscriptionInfoMsg();
          }
        } else if (shouldRunWithStripeFlow || shouldRunUpdateAgent) {
          await callNextApiAndRedirect();
          await new Promise((resolve) => setTimeout(resolve, 1500));
          await fetchSubscriptionInfo();
        } else if (shouldRunCreateFlow) {
          await new Promise((resolve) => setTimeout(resolve, 1500));
          await fetchSubscriptionInfo();
          if (!hasHandledThankYou) onSubmit();
        } else {
          // isPayg ya koi aur case — bas loading band karo
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [key, subscriptionId, agentId, userId, subsid, isAdmin]);

  const formatCurrency = (amount, currency) => {
    const upperCurrency = currency?.toUpperCase() || "USD";
    const symbolMap     = { USD: "$", INR: "₹", EUR: "€", GBP: "£", AUD: "A$", CAD: "C$" };
    const symbol        = symbolMap[upperCurrency] || "";
    return `${upperCurrency} ${symbol}${Number(amount).toLocaleString()}`;
  };

  useEffect(() => {
    fetch("/animations/Lottie_Loader.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Error loading animation:", err));
  }, []);

  useEffect(() => {
    if (loading || !subscriptionInfo) return;
    if (convFiredRef.current) return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "conversion", {
      send_to: "AW-17437749926/M6gmCJzi-v8aEKbl-_pA",
      value: Number(subscriptionInfo.planAmount || 1.0),
      currency: (subscriptionInfo.currency || "USD").toUpperCase(),
      transaction_id:
        subscriptionInfo.subscriptionId || `${userId || "uid"}-${Date.now()}`,
    });
    convFiredRef.current = true;
  }, [loading, subscriptionInfo, subscriptionId, userId]);

  // ─────────────────────────────────────────
  // ✅ isPayg UI — loading khatam hone ka wait karo
  // Route change SIRF button click pe
  // ─────────────────────────────────────────
  if (isPayg === "true") {
    if (loading) return <Loader2 />;

    return (
      <div className={styles.container}>
        <div className={styles.Logo}>
          <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
        </div>

        <div className={styles.ThankyouMsg}>
          <div className={styles.title}>Thanks!</div>
          <div className={styles.subtitle}>for your Purchase</div>
          <p className={styles.description}>
            Your payment was successful. We've sent you a confirmation email
            with all the details you need.
          </p>
        </div>

        <div className={styles.infoBox}>
          <p>Below is some Quick Info for your Reference:</p>

          <div className={styles.row}>
            <span>Business Name:</span>
            <div className={styles.Right50}>{displayBusinessName}</div>
          </div>

          <div className={styles.row}>
            <span>Agent Name & ID:</span>
            <div className={styles.Right50}>
              {displayAgentName} ({displayAgentCode})
            </div>
          </div>

          <div className={styles.row}>
            <span>Subscription or Plan Activated:</span>
            <div className={styles.Right50}>VoIP Number ($5.00/mo)</div>
          </div>

          <div className={styles.row}>
            <span>Billed Today:</span>
            <div className={styles.Right50}>
              $5.00 on {formatDate(paygBilledDate)}
            </div>
          </div>

          <div className={styles.row}>
            <span>Next Billing:</span>
            <div className={styles.Right50}>
              {formatDate(paygNextBillingDate)} ($5.00)
            </div>
          </div>

          <div className={styles.row}>
            <span>Sign-up Bonus:</span>
            <div className={styles.Right50}>
              50 Mins Included (First month only)
            </div>
          </div>

          <div className={styles.row}>
            <span>Pay-As-You-Go Rate:</span>
            <div className={styles.Right50}>$0.41/min</div>
          </div>

          <div className={styles.row}>
            {/* <span>Note:</span> */}
            <div className={styles.Right50}>
             Note: Your $5.00 monthly fee keeps your agent's phone line active. You
              only pay for the minutes your agent actually uses at $0.50/min.
              We've included 50 free minutes to get you started this month!
            </div>
          </div>

          <div className={styles.ButtonTakeME}>
            {/* ✅ onDashboardClick → adminHandleClick → token store → /number-assign */}
            <button
              onClick={onDashboardClick}
              disabled={isButtonDisabled || isLoadingRequest}
              className={styles.dashboardBtn}
            >
              {isLoadingRequest ? "Redirecting..." : "Take me to Number Assign"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────
  // Default UI — as it is, bilkul same
  // ─────────────────────────────────────────
  return (
    <>
      {showAnimation ? (
        <>
          <div className={styles.container}>
            <br /> <br />
            <div className={styles.Logo}>
              <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
            </div>
          </div>
          <div className={styles.animationContainer}>
            <div className={styles.animationContent}>
              <LottieAnimation animationData={animationData} width={300} height={300} />
              <p className={styles.loaderText}>
                <b>Setting up your agent... </b>
                <br />
                <br /> Please Wait
              </p>
            </div>
          </div>
        </>
      ) : loading ? (
        // Loader shown ONLY while we're actually fetching. Earlier this branch
        // was gated on `subscriptionInfo` presence, which left flows that
        // never set it (post-purchase, API failure, canceled subscription)
        // stuck on the loader forever — hard refresh "fixed" it because a
        // remount restarted the fetch lottery.
        // Now: if loading is false but subscriptionInfo is null, the page
        // still renders with the existing field-level fallbacks
        // (`planName || "Growth"`, `planMins || "1500"`, etc.) so the user
        // can read the thank-you message and proceed.
        <Loader2 />
      ) : (
        <div>
          <div className={styles.container}>
            <div className={styles.Logo}>
              <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
            </div>

            <div className={styles.ThankyouMsg}>
              {isPostPurchase ? (
                <>
                  <div className={styles.title}>Thank you </div>
                  <div className={styles.subtitle}>
                    for your purchase
                    {/* {displayBusinessName && displayBusinessName !== "Your Business" && (
                      <>
                        ,{" "}
                        <span style={{ color: "#6524EB" }}>
                          {displayBusinessName}
                        </span>
                      </>
                    )} */}
                  </div>
                  <p className={styles.description01}>
                    For your Receptionist to work efficiently</p>
                  <p className={styles.description}>                    
                    Grant access to{" "}<b>Google Calendar</b> and other Google services, and{" "}
                    <b>verify your business details</b>.
                  </p>
                </>
              ) : (
                <>
                  <div className={styles.title}>Thanks!</div>
                  <div className={styles.subtitle}>for your Purchase</div>
                  <p className={styles.description}>
                    Your payment was successful. We've sent you a confirmation email
                    with all the details you need.
                  </p>
                </>
              )}
            </div>

            {loading ? (
              <Loader2 />
            ) : (
              <div className={styles.infoBox}>
                  {!isPostPurchase && <p>Below is some Quick Info for your Reference:</p>}
                {/* Resolve once and only render the row when there's
                    actually a business name to show — empty label looked
                    like a broken field in the post-purchase variant
                    where the name often isn't carried through. */}
                {(() => {
                  const resolvedBizName = isAdmin
                    ? businessName1
                    : key === "msgPlan"
                    ? sessionStorage.getItem("bussinessName")
                    : businessName;
                  if (!resolvedBizName) return null;
                  return (
                    <div className={styles.row}>
                      <span>Business Name:</span>
                      <div className={styles.Right50}>{resolvedBizName}</div>
                    </div>
                  );
                })()}
                {/* Resolve agent name + code from the same precedence as
                    displayBusinessName above. Hide the row entirely when
                    we have neither — beats showing the placeholder
                    "Oliver (HS23D4)" that confused users into thinking
                    we'd assigned them a different agent. */}
                {(() => {
                  const resolvedAgentName = isPostPurchase
                    ? agentName || agentName1
                    : isAdmin
                    ? agentName1
                    : agentName;
                  const resolvedAgentCode = isPostPurchase
                    ? agentCode || agentCode1
                    : isAdmin
                    ? agentCode1
                    : agentCode;
                  if (!resolvedAgentName && !resolvedAgentCode) return null;
                  const display =
                    resolvedAgentName && resolvedAgentCode
                      ? `${resolvedAgentName} (${resolvedAgentCode})`
                      : resolvedAgentName || resolvedAgentCode;
                  return (
                    <div className={styles.row}>
                      <span>Agent Name & ID:</span>
                      <div className={styles.Right50}>{display}</div>
                    </div>
                  );
                })()}
                {(() => {
                  // Fake "Growth - 1500 Minutes" fallback removed — that
                  // misled trial users (Starter $20 / 21-day) into seeing
                  // the highest tier they hadn't actually bought. Hide
                  // the row entirely until subscriptionInfo arrives.
                  const planName = subscriptionInfo?.planName;
                  const planQty =
                    key === "msgPlan"
                      ? subscriptionInfo?.planMessage
                      : subscriptionInfo?.planMins;
                  if (!planName && !planQty) return null;
                  return (
                    <div className={styles.row}>
                      <span>Plan Activated:</span>
                      <div className={styles.Right50}>
                        {planName || "—"}
                        {planQty
                          ? ` - ${planQty}${key === "msgPlan" ? " Messages" : " Minutes"}`
                          : ""}
                      </div>
                    </div>
                  );
                })()}
                {!isPostPurchase && (
                  <>
                <div className={styles.row}>
                  <span>Frequency & Price:</span>
                  <div className={styles.Right50}>
                    {isFree === "true" ? (
                      "US $299 / month"
                    ) : subscriptionInfo?.metadata?.original_plan_amount &&
                      subscriptionInfo?.interval ? (
                      `${currencySymbol}${formatPrice(
                        subscriptionInfo.metadata.original_plan_amount
                      )} / ${subscriptionInfo.interval}`
                    ) : (
                      // No more "US $499 / month" fake fallback.
                      "—"
                    )}
                  </div>
                </div>
                <div className={styles.row}>
                  <span>Billed Today:</span>
                  <div className={styles.Right50}>
                    {subscriptionInfo ? (
                      <>
                        {`${currencySymbol}${formatPrice(subscriptionInfo.planAmount)} on `}
                        {new Date(
                          subscriptionInfo.currentPeriodStart
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </>
                    ) : (
                      "$5,688.60 on July 12, 2025"
                    )}
                  </div>
                </div>
                <div className={styles.row}>
                  <span>Next Billing Date:</span>
                  <div className={styles.Right50}>
                    {subscriptionInfo ? (
                      isFree === "true" ? (
                        new Date(
                          new Date(subscriptionInfo.currentPeriodStart).getTime() +
                            7 * 24 * 60 * 60 * 1000
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      ) : (
                        new Date(subscriptionInfo.nextRenewalDate).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      )
                    ) : (
                      "06 July 2026"
                    )}
                  </div>
                </div>
                </>
                )}
                {invoiceLink && (
                  <div className={styles.row}>
                    <span>Invoice Link:</span>
                    <div className={styles.Right50}>
                      <a
                        href={invoiceLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.downloadButton}
                        style={{
                          color: "purple",
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        download
                      >
                        Download
                      </a>
                    </div>
                  </div>
                )}
                <div className={styles.ButtonTakeME}>
                  {/* Post-purchase variant uses AnimatedButton2 (white body,
                      purple text) because the InfoBox below it renders on
                      brand purple — the regular purple-themed AnimatedButton
                      visually disappears into that background. Other flows
                      (create/update) keep AnimatedButton since their InfoBox
                      sits on a light surface. */}
                  {/* Both variants now use AnimatedButton2 (white body /
                      purple text). The earlier conditional split sent
                      non-postPurchase visitors to the regular purple
                      AnimatedButton — but the surrounding InfoBox is
                      brand-purple in BOTH variants, so the purple
                      button visually disappeared and the unloaded
                      svg-theme2.svg image showed as a broken icon
                      ("Take Me To Dashboard" overlapping a placeholder
                      glyph in the screenshot). White button with
                      purple text reads cleanly on the purple surface
                      regardless of variant. Label still varies by
                      flow (Grant Access vs Take me to Dashboard etc). */}
                  <AnimatedButton2
                    onClick={onDashboardClick}
                    isLoading={isLoadingRequest}
                    disabled={
                      isButtonDisabled ||
                      isLoadingRequest ||
                      (key === "create" ? !isAgentCreated : false)
                    }
                    positionType="relative"
                    bottom={0}
                    label={
                      isLoadingRequest
                        ? "Redirecting..."
                        : isPostPurchase
                        ? "Grant Access"
                        : key === "create"
                        ? isAgentCreated
                          ? "Take me to Dashboard"
                          : "Thinking..."
                        : "Take me to Dashboard"
                    }
                  />
                  {/* Post-purchase flag on → give a small escape hatch to
                      jump straight to the agent's fast-detail page,
                      bypassing the wizard. Primary CTA above still
                      routes through the wizard via defaultHandleClick /
                      adminHandleClick. Earlier this went to /dashboard
                      (admin/legacy workspace) — non-admin users belong
                      on /fast-agent-detail. */}
                  {isPostPurchase && (
                    <button
                      type="button"
                      onClick={() => {
                        localStorage.setItem("paymentDone", "true");
                        if (agentId) {
                          sessionStorage.setItem("SelectAgentId", agentId);
                          localStorage.setItem("postPurchaseAgentId", agentId);
                        }
                        localStorage.removeItem("selectedPlanData");
                        localStorage.removeItem("allPlans");
                        navigate("/fast-agent-detail", { replace: true });
                      }}
                      style={{
                        marginTop: 15,
                        display: "block",
                        background: "transparent",
                        border: "none",
                        fontSize: 13,
                        color: "#c4bfbf",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0,
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      Take me to dashboard
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Thankyou;
